import { h } from 'preact';
import * as BaseComp from 'components/bolt/expandableTextList/question.js';
import s from 'components/bolt/expandableTextList/question.sss';
import { joinClasses } from 'utils/utils';
import HTML from 'components/core/html/html.js';
import { sortObjectByOrder } from 'utils/utils';
import Store from 'store/store';

export default class Question extends BaseComp.default {
	constructor(props) {
		super(props);
		this.changeActiveKey = this.changeActiveKey.bind(this);

		this.state = {
			activeKey: null
		};

	}

	changeActiveKey(key) {
		const { activeKey } = this.state;
		if (key !== activeKey) {
			this.setState({ activeKey: key });

			Store.emit('CUSTOM_EVENT', {
				category: this.props.id,
				action: 'faq-click',
				label: this.props.parentKey + '_' + key
			});

		} else {
			this.setState({ activeKey: null });
		}
	}

	answerRef(ref) {
		this.$answer = ref;
	}


	renderQuestionText() {
		return this.props.question;
	}

	renderQuestion() {
		return (
			<button class={joinClasses(s.title, 'large')} onClick={this.props.toggleActive}>
				{this.renderQuestionText()}
				<div class={joinClasses(this.props.isOpen && s.open, this.props.hasNested ? s.icon : s.iconNested)} />
			</button>
		);
	}

	renderAnswer() {
		if (this.props.hasNested) {
			return (
				<div class={s.content} ref={this.answerRef} onClickCapture={this.onClick}>
					{this.renderNested()}
				</div>
			);
		}
		return <HTML class={s.content} content={this.props.answer} markdown ref={this.answerRef} onClickCapture={this.onClick} />;
	}

	render(props) {
		const { isOpen } = props;
		return (
			<div class={joinClasses(s.section, isOpen && s.open)}>
				{this.renderQuestion()}
				{this.renderAnswer()}
			</div>
		);
	}

	renderNested() {
		const { nestedQuestions } = this.props;
		let hasNested = false;
		return (
			<div class={s.nestedQuestions} key="questions">
				{sortObjectByOrder(nestedQuestions, (data, key) => {
					const { type, question, answer } = data;
					if (type === 'separator') {
						return <div class={s.separator}>{question}</div>;
					}

					return (
						<Question
							key={key}
							question={!!question && <HTML markdown content={question} class={question} inline />}
							answer={answer}
							isOpen={this.state.activeKey === key}
							toggleActive={() => this.changeActiveKey(key)}
							hasNested={hasNested}
						/>
					);
				})}
			</div>
		);		
	}
}
